import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-info-details',
  templateUrl: './app-info-details.component.html',
  styleUrls: ['./app-info-details.component.scss']
})
export class AppInfoDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
